import { Route, Routes } from "react-router-dom"
import NotificationAssignmentList from "./components/NotificationAssignmentList"

export default function NotificationAssignmentsPage() {
  return (
    <Routes>
      <Route index element={<NotificationAssignmentList />} />
    </Routes>
  )
}
